export default __webpack_public_path__ + "static/media/secure.072f113b.webp";